import { Box, Container, Grid, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import { WhiteSection } from "../../styles/HomeStyles";
import BannerCard from "./BannerCard";

const Banner = () => {
  const theme = useTheme();
  return (
    <Container sx={{ mb: 15 }}>
      <Box>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: "", sm: "center" }}
          my={{ xs: 5, sm: 0 }}
        >
          <Grid item xs={12} sm={6} lg={6} order={{ xs: 2, sm: 1 }}>
            <BannerCard />
          </Grid>
          <Grid item xs={12} sm={6} lg={6} order={{ xs: 1, sm: 2 }}>
            <Box
              component={motion.div}
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              transition={{
                repeat: "Infinity",
                repeatType: "reverse",
                duration: 1,
                repeatDelay: 0.2,
              }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <img style={{ width: "70%" }} src="./static/images/logo.png" />
            </Box>
            <Box
              component={motion.div}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 120,
              }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <img
                style={{ width: "70%" }}
                src="./static/images/afriqualeosTitle.png"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Banner;
